export default __webpack_public_path__ + "b7020f594a32dda22777c5e06317ee6f.svg";